<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titles.FunctionalyInfo}}</h4>
            <TabModule :selectedTab="tabs[0]" :tabs="tabs" @method="changeModule"/>
            <TabFunctionality :existFunctionlities="existFunctionlities" :idModule="selectedModule.id"
                              :restFunctionlities="restFunctionlities" :selectedModule="selectedModule"
                              v-if="selectedModule.id!=null"/>
        </div>
        <modal-success :title="titles.updatePackCountryDomain" id="success-pack-country-domain"/>
    </div>
</template>

<script>
    import {titles} from '../../../utils/general/titles';
    import {getAllModules} from '../services/module.service';
    import {module} from '@/components/shared/models/module';
    import TabModule from './TabModule';
    import TabFunctionality from './TabFunctionality';
    import {filterMixin} from '../../../utils/filterMixin';
    import {packCountryDomain} from '../models/packCountryDomain';
    import ModalSuccess from '../../common/modal-success';
    import {getExistAndRestFunctionalities} from '../services/packCountryDomainFunctionality.service';
    import {errorMixin} from '../../../utils/errorMixin';

    export default {
        name: 'FunctionalityInfo',
        components: {TabFunctionality, TabModule, ModalSuccess},
        data() {
            return {
                titles,
                items: [],
                tabs: [],
                selectedModule: module(),
                isLoading: false,
                formComponent: packCountryDomain(),
                filterList: [],
                existFunctionlities: [],
                restFunctionlities: []
            };
        },
        created() {
            this.loadModules();
        },
        mixins: [filterMixin, errorMixin],
        methods: {
            async loadModules() {
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'isActive',
                    '1',
                    null
                );
                await getAllModules(1000,1,null,this.filterQuery
                ).then(response => {
                    this.items = response.data['hydra:member'];
                    this.items = this.items.map(item => {
                        this.tabs.push({
                            name: item.label,
                            item
                        });
                        return module(item);
                    });
                });
            },
            changeModule(val) {
                this.selectedModule = val;
                this.getFunctionalities(this.selectedModule.id);
            },
            getFunctionalities(id) {
                this.formComponent = this.$cookies.get('pack');
                getExistAndRestFunctionalities(id, this.formComponent.id)
                    .then(response => {
                        this.existFunctionlities = response.data['pack'];
                        this.restFunctionlities = response.data['module'];
                        return response;
                    });
            }
        }
    };
</script>

<style scoped>

</style>